import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { addCostCenterItem, editCostCenterItem } from 'features/inventory/inventoryCostCenterSlice'
import useModalClose from 'hooks/useModalClose'
import { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const InventoryCostCenterModal = ({ closeModal, value }: { closeModal: any, value?: IInventoryCostCenterModal }) => {
    const [state, setState] = useState(value || {
        name: '',
        code: '',
        ownerUser: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(state?.id ? editCostCenterItem(state) : addCostCenterItem(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleSelect = (v: ISelectValue) => {
        setState(prev => ({ ...prev, ownerUser: v }))
    }

    const checkValid = useMemo(() => {
        return !state.name || !state.code || !state.ownerUser?.value
    }, [state])

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Record</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input name='name' placeholder='Enter name...' labelText='Name' value={state?.name} onChange={handleChange} nomarg />
                <Input name='code' placeholder='Enter code...' labelText='Code' value={state?.code} onChange={handleChange} nomarg />
                <HonestSelectAsyncInput
                    link='users/basic'
                    labelText='Owner'
                    name='ownerUser'
                    onChange={handleSelect}
                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, value: i.id }))}
                    defaultValue={state.ownerUser?.label}
                />
            </Flex>
            <Button disabled={checkValid} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IInventoryCostCenterModal {
    id?: number
    name: string
    code: string
    ownerUser: ISelectValue
}